import useTranslation, { Iprefix } from "src/hooks/useTranslation";
import { useGenGridCol } from "src/utils/HelperComp";
import { TableColumnKey } from "../../../types/Table";
import useOperationButton from "./useOperationButton";
import usePermission from "src/hooks/usePermission";
import { FeatureCode } from "@wallet-manager/node-types";

const useTableColumns = ({ translatePrefix }: { translatePrefix: Iprefix }) => {
  const { t } = useTranslation(translatePrefix);
  const { renderOperationButtons } = useOperationButton();

  const { hasPermissionMultipleEither } = usePermission();

  const columns = [
    useGenGridCol(TableColumnKey.Operation, t(TableColumnKey.Operation), {
      renderCell: renderOperationButtons,
      minWidth: 140,
    }),
    useGenGridCol(TableColumnKey.ClientId, t(TableColumnKey.ClientId), {
      minWidth: 260,
    }),
    useGenGridCol(TableColumnKey.ChainName, t(TableColumnKey.ChainName)),
    useGenGridCol(TableColumnKey.Currency, t(TableColumnKey.Currency)),
    useGenGridCol(TableColumnKey.AlertTypeName, t(TableColumnKey.AlertType)),
    useGenGridCol(
      TableColumnKey.ThresholdLower,
      t(TableColumnKey.ThresholdLower),
      {
        minWidth: 160,
      },
    ),
    useGenGridCol(
      TableColumnKey.ThresholdUpper,
      t(TableColumnKey.ThresholdUpper),
      {
        minWidth: 160,
      },
    ),
    useGenGridCol(TableColumnKey.CreationTime, t(TableColumnKey.CreationTime), {
      minWidth: 130,
    }),
    useGenGridCol(
      TableColumnKey.LastModifiedTime,
      t(TableColumnKey.LastModifiedTime),
      {
        minWidth: 130,
      },
    ),
  ];
  return {
    columns: columns.filter(
      (col) =>
        col.field !== TableColumnKey.Operation ||
        hasPermissionMultipleEither([
          FeatureCode.FeaturesLedger.LedgerBalanceMonitor.Edit,
          FeatureCode.FeaturesLedger.LedgerBalanceMonitor.Delete,
        ]),
    ),
  };
};

export default useTableColumns;
